import React from "react";

import NumberInput from "./NumberInput";
import { FieldOption } from "./optionLabel";
import { toYenString } from "../../utils/money";

/**
 * 金額（円）入力フィールド。
 *
 * `NumberInput` をラップした「円・整数」専用の入力。対価など円の入力は
 * すべて本コンポーネントを使い、小数点が入力・表示・保存に混入しないようにする。
 *
 * - 入力は整数のみ（`allowDecimal` を付けない）。
 * - API/DB 由来の値が小数文字列（`"1000.0"` 等）でも、表示前に整数へ正規化する。
 * - 末尾に単位（既定 `"円"`）を表示する。
 *
 * 数量など小数が必要な数値は本コンポーネントではなく
 * `NumberInput`（`allowDecimal`）を使うこと。
 */
interface MoneyInputProps {
  label?: string;
  option?: FieldOption | string;
  placeholder?: string;
  /** 整数円の数値文字列（例: `"1000"`） */
  value?: string;
  /** カンマ等を除いた整数円の数値文字列が入る */
  onChange?: (e: { target: { value: string } }) => void;
  /** 末尾に表示する単位ラベル（既定 `"円"`） */
  suffix?: string;
  width?: string;
  name?: string;
}

const MoneyInput: React.FC<MoneyInputProps> = ({
  value,
  suffix = "円",
  ...rest
}) => (
  <NumberInput
    {...rest}
    suffix={suffix}
    value={value === undefined || value === "" ? value : toYenString(value)}
  />
);

export default MoneyInput;
